// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2SyMV","row":"ProcedureTreatmentSummary_row__2Ksvg"};